// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  InputNumber,
  DatePicker
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';
import type { UserCouponItem } from './user-types';
import type { CouponItem } from './types';
import type { GameItem } from '../game/types';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function UserCouponManagement() {
  const [formSearch] = Form.useForm();
  const [sendForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UserCouponItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [couponList, setCouponList] = useState<CouponItem[]>([]);
  const [gameConfigList, setGameConfigList] = useState<GameItem[]>([]);
  const [currentEditRecord, setCurrentEditRecord] = useState<UserCouponItem | null>(null);

  // 卡券状态选项
  const couponStatusOptions = [
    { label: '未使用', value: '1' },
    { label: '已使用', value: '0' },
    { label: '已过期', value: '-1' }
  ];

  // 是否有效选项
  const isValidOptions = [
    { label: '有效', value: 1 },
    { label: '无效', value: 0 }
  ];

  // 卡券类型选项
  const couponTypeOptions = [
    { label: '常规赛卡券', value: 1 },
    { label: '半年赛卡券', value: 2 }
  ];

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(20);
    getList(true);
  };

  // 获取赛季配置列表
  const getGameConfigList = () => {
    get('/gameConfig/list', { pageNum: 1, pageSize: 1000 })
      .then((res: any) => {
        const { list } = res.data || {};
        setGameConfigList(list || []);
      })
      .catch(() => {
        Message.error('获取赛季配置列表失败!');
      });
  };

  // 根据核销时间和卡券类型判断所属赛季
  const getGameSessionByUseTime = (useTime: string | undefined, couponType: number | undefined): string => {
    if (!useTime || !couponType) {
      return '-';
    }

    const useDate = dayjs(useTime);
    
    // 卡券类型映射到比赛类型：1-常规赛卡券对应1-常规赛，2-半年赛卡券对应2-半年赛
    const gameTypeMap: Record<number, number> = {
      1: 1, // 常规赛卡券 -> 常规赛
      2: 2  // 半年赛卡券 -> 半年赛
    };
    
    const targetGameType = gameTypeMap[couponType];
    if (!targetGameType) {
      return '-';
    }

    // 查找匹配的赛季：时间在范围内且比赛类型匹配
    const matchedGame = gameConfigList.find(game => {
      if (game.gameType !== targetGameType) {
        return false;
      }
      
      if (!game.gameStartTime || !game.gameEndTime) {
        return false;
      }
      
      const startDate = dayjs(game.gameStartTime);
      const endDate = dayjs(game.gameEndTime);
      
      // 判断 useTime 是否在赛季时间范围内（包含边界）
      // 使用 diff 方法判断：diff >= 0 表示 useDate >= startDate，diff <= 0 表示 useDate <= endDate
      const diffStart = useDate.diff(startDate, 'day');
      const diffEnd = useDate.diff(endDate, 'day');
      return diffStart >= 0 && diffEnd <= 0;
    });

    return matchedGame ? matchedGame.gameSessionName : '-';
  };

  // 获取卡券列表（用于下发选择）
  const getCouponList = () => {
    get('/coupon/list', { pageNum: 1, pageSize: 1000, isValid: 1 })
      .then((res: any) => {
        const { list } = res.data || {};
        setCouponList(list || []);
      })
      .catch(() => {
        Message.error('获取卡券列表失败!');
      });
  };

  // 打开下发弹框
  const openSendModal = () => {
    getCouponList();
    sendForm.resetFields();
    sendForm.setFieldsValue({
      count: 1
    });
    setVisible(true);
  };

  // 关闭下发弹框
  const closeSendModal = () => {
    setVisible(false);
    sendForm.resetFields();
  };

  // 提交下发
  const handleSendCoupon = () => {
    sendForm.validate().then(values => {
      setSendLoading(true);
      // 后端使用 @RequestParam，参数通过 URL 查询参数传递
      const params = new URLSearchParams({
        openId: values.openId,
        couponId: String(values.couponId),
        count: String(values.count)
      });
      post(`/userCoupon/batchSendCoupon?${params.toString()}`)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success('卡券下发成功！');
            getList();
            closeSendModal();
          } else {
            Message.error(message || '卡券下发失败');
          }
        })
        .catch(e => {
          // Message.error('网络错误!');
          console.log(e);
        })
        .finally(() => {
          setSendLoading(false);
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  // 判断卡券状态显示
  const getCouponStatusDisplay = (status: string, record: UserCouponItem) => {
    // 如果已过期
    if (record.couponEndTime) {
      const endDate = dayjs(record.couponEndTime);
      if (endDate.isBefore(dayjs(), 'day')) {
        return { text: '已过期', color: '#86909C', bgColor: '#F2F3F5' };
      }
    }
    
    // 根据状态值判断
    if (status === '1') {
      return { text: '未使用', color: '#00B42A', bgColor: '#E8F8F0' };
    } else if (status === '0') {
      return { text: '已使用', color: '#86909C', bgColor: '#F2F3F5' };
    } else if (status === '-1') {
      return { text: '已过期', color: '#86909C', bgColor: '#F2F3F5' };
    }
    
    // 如果状态为1且未过期，显示可使用
    if (status === '1' && record.couponEndTime) {
      const endDate = dayjs(record.couponEndTime);
      if (!endDate.isBefore(dayjs(), 'day')) {
        return { text: '可使用', color: '#00B42A', bgColor: '#E8F8F0' };
      }
    }
    
    return { text: '未知', color: '#86909C', bgColor: '#F2F3F5' };
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '发券id',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '用户名',
      dataIndex: 'gameName',
      width: 120
    },
    {
      title: 'openid',
      dataIndex: 'openId',
      width: 150
    },
    {
      title: '卡券类型',
      dataIndex: 'couponType',
      width: 120,
      render: (text) => {
        const typeMap: Record<number, string> = {
          1: '常规赛优惠券',
          2: '半年赛优惠券'
        };
        return typeMap[text] || text;
      }
    },
    {
      title: '卡券配置id',
      dataIndex: 'couponId',
      width: 100
    },
    {
      title: '卡券编码',
      dataIndex: 'couponCode',
      width: 200
    },
    // {
    //   title: '订单编号',
    //   dataIndex: 'orderId',
    //   width: 150,
    //   render: text => text || '-'
    // },
    {
      title: '使用赛季',
      dataIndex: 'gameSession',
      width: 100,
      render: (text, record) => {
        // 如果有核销时间，通过核销时间判断赛季
        if (record.useTime) {
          return getGameSessionByUseTime(record.useTime, record.couponType);
        }
        // 否则显示原有的 gameSession 字段
        return text || '-';
      }
    },
    {
      title: '卡券金额(元)',
      dataIndex: 'couponValue',
      width: 100,
      render: (text) => {
        // couponValue 单位是元
        return text || '-';
      }
    },
    {
      title: '卡券生效时间',
      dataIndex: 'couponStartTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : '-'
    },
    {
      title: '卡券过期时间',
      dataIndex: 'couponEndTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : '-'
    },
    {
      title: '卡券下发时间',
      dataIndex: 'createTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
        title: '卡券核销时间',
        dataIndex: 'useTime',
        width: 150,
        render: text => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      title: '有效天数（旧版）',
      dataIndex: 'expireDays',
      width: 150,
      render: text => text || '-'
    },
    {
      title: '是否有效',
      dataIndex: 'isValid',
      width: 100,
      render: (text) => (
        <Switch checked={text === 1} disabled />
      )
    },
    {
      title: '卡券状态',
      dataIndex: 'couponStatus',
      width: 120,
      render: (text, record) => {
        const statusInfo = getCouponStatusDisplay(text, record);
        return (
          <span
            style={{
              padding: '2px 8px',
              borderRadius: '4px',
              backgroundColor: statusInfo.bgColor,
              color: statusInfo.color,
              fontSize: '12px'
            }}
          >
            {statusInfo.text}
          </span>
        );
      }
    },
    {
      title: '单人最多张数',
      dataIndex: 'maxCountPerUser',
      width: 120,
      render: text => text !== null && text !== undefined ? text : '-'
    },
    {
      title: '操作',
      width: 100,
      fixed: 'right',
      render: (_text, record) => (
        <Button type="text" size="small" onClick={() => openEditModal(record)}>
          编辑
        </Button>
      )
    }
  ];

  // 打开编辑弹框
  const openEditModal = (record: UserCouponItem) => {
    setCurrentEditRecord(record);
    editForm.setFieldsValue({
      id: record.id,
      couponStartTime: record.couponStartTime ? dayjs(record.couponStartTime) : undefined,
      couponEndTime: record.couponEndTime ? dayjs(record.couponEndTime) : undefined,
      // useTime: record.useTime ? dayjs(record.useTime) : undefined, // 卡券核销时间暂不允许编辑
      isValid: record.isValid === 1 || record.isValid === '1',
      couponStatus: record.couponStatus
    });
    setEditVisible(true);
  };

  // 关闭编辑弹框
  const closeEditModal = () => {
    setEditVisible(false);
    setCurrentEditRecord(null);
    editForm.resetFields();
  };

  // 提交编辑
  const handleEditCoupon = () => {
    editForm.validate().then(values => {
      setEditLoading(true);
      const data = {
        id: values.id,
        couponStartTime: values.couponStartTime ? dayjs(values.couponStartTime).format('YYYY-MM-DD') : null,
        couponEndTime: values.couponEndTime ? dayjs(values.couponEndTime).format('YYYY-MM-DD') : null,
        // useTime: values.useTime ? dayjs(values.useTime).format('YYYY-MM-DD HH:mm:ss') : null, // 卡券核销时间暂不允许编辑
        isValid: values.isValid === true || values.isValid === 1 ? 1 : 0,
        couponStatus: values.couponStatus
      };
      
      post('/userCoupon/update', data)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success('卡券修改成功！');
            getList();
            closeEditModal();
          } else {
            Message.error(message || '卡券修改失败');
          }
        })
        .catch(e => {
          console.log(e);
          Message.error('网络错误!');
        })
        .finally(() => {
          setEditLoading(false);
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  // 获取数据列表
  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(20);
    }

    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize
    };

    get('/userCoupon/list', params)
      .then((res: any) => {
        const { list, total } = res.data || {};
        setTotal(total);
        setDataList(list || []);
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getGameConfigList();
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="user-coupon-management table-flex">
      <Space style={{ flexWrap: 'wrap', marginBottom: 16, justifyContent: 'space-between', width: '100%' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="用户名" field="gameName">
            <Input placeholder="请输入..." style={{ width: 150 }} allowClear />
          </FormItem>
          <FormItem label="卡券类型" field="couponType">
            <Select style={{ width: 120 }} allowClear placeholder="请选择">
              {couponTypeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否有效" field="isValid">
            <Select style={{ width: 120 }} allowClear placeholder="请选择">
              {isValidOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="卡券状态" field="couponStatus">
            <Select style={{ width: 120 }} allowClear placeholder="请选择">
              {couponStatusOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
        </Form>
        <Button className="filter-item" type="primary" onClick={openSendModal} loading={loading}>
          卡券下发
        </Button>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            sizeOptions: [20, 30, 50, 100],
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
          loading={loading}
        />
      </div>
      
      {/* 卡券下发弹框 */}
      <Modal
        title="卡券下发"
        visible={visible}
        onCancel={closeSendModal}
        onOk={handleSendCoupon}
        unmountOnExit
        style={{ width: 500 }}
        confirmLoading={sendLoading}
      >
        <Form {...formItemLayout} form={sendForm}>
          <FormItem label="openid" field="openId" rules={[{ required: true, message: '请输入openid' }]}>
            <Input placeholder="请输入openid" />
          </FormItem>
          <FormItem label="卡券" field="couponId" rules={[{ required: true, message: '请选择卡券' }]}>
            <Select placeholder="请选择卡券" showSearch filterOption={(inputValue, option) => 
              option?.children?.toString().toLowerCase().includes(inputValue.toLowerCase())
            }>
              {couponList.map(coupon => (
                <Option key={coupon.id} value={coupon.id}>
                  {coupon.couponName} ({coupon.code})
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="下发数量" field="count" rules={[{ required: true, message: '请输入下发数量' }]}>
            <InputNumber 
              placeholder="请输入下发数量" 
              style={{ width: '100%' }} 
              min={1} 
              precision={0}
            />
          </FormItem>
        </Form>
      </Modal>

      {/* 编辑卡券弹框 */}
      <Modal
        title="编辑用户卡券"
        visible={editVisible}
        onCancel={closeEditModal}
        onOk={handleEditCoupon}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={editLoading}
      >
        <Form {...formItemLayout} form={editForm}>
          <FormItem field="id" style={{ display: 'none' }}>
            <Input />
          </FormItem>
          <FormItem label="卡券生效时间" field="couponStartTime">
            <DatePicker 
              placeholder="请选择卡券生效时间" 
              style={{ width: '100%' }}
              format="YYYY-MM-DD"
            />
          </FormItem>
          <FormItem label="卡券过期时间" field="couponEndTime">
            <DatePicker 
              placeholder="请选择卡券过期时间" 
              style={{ width: '100%' }}
              format="YYYY-MM-DD"
            />
          </FormItem>
          {/* 卡券核销时间暂不允许编辑 */}
          {/* <FormItem label="卡券核销时间" field="useTime">
            <DatePicker 
              placeholder="请选择卡券核销时间" 
              style={{ width: '100%' }}
              showTime
              format="YYYY-MM-DD HH:mm:ss"
            />
          </FormItem> */}
          <FormItem label="是否有效" field="isValid" triggerPropName="checked">
            <Switch checkedText="有效" uncheckedText="无效" />
          </FormItem>
          <FormItem label="卡券状态" field="couponStatus">
            <Select placeholder="请选择卡券状态" style={{ width: '100%' }}>
              {couponStatusOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default UserCouponManagement;

